"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolProgressToJSON = exports.CommunityPoolProgressFromJSONTyped = exports.CommunityPoolProgressFromJSON = void 0;
var runtime_1 = require("../runtime");
function CommunityPoolProgressFromJSON(json) {
    return CommunityPoolProgressFromJSONTyped(json, false);
}
exports.CommunityPoolProgressFromJSON = CommunityPoolProgressFromJSON;
function CommunityPoolProgressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalCommittedUsd': !(0, runtime_1.exists)(json, 'totalCommittedUsd') ? undefined : json['totalCommittedUsd'],
        'totalPoolSizeUsd': !(0, runtime_1.exists)(json, 'totalPoolSizeUsd') ? undefined : json['totalPoolSizeUsd'],
        'percentageCommitted': !(0, runtime_1.exists)(json, 'percentageCommitted') ? undefined : json['percentageCommitted'],
        'remainingAvailableUsd': !(0, runtime_1.exists)(json, 'remainingAvailableUsd') ? undefined : json['remainingAvailableUsd'],
        'totalParticipants': !(0, runtime_1.exists)(json, 'totalParticipants') ? undefined : json['totalParticipants'],
    };
}
exports.CommunityPoolProgressFromJSONTyped = CommunityPoolProgressFromJSONTyped;
function CommunityPoolProgressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totalCommittedUsd': value.totalCommittedUsd,
        'totalPoolSizeUsd': value.totalPoolSizeUsd,
        'percentageCommitted': value.percentageCommitted,
        'remainingAvailableUsd': value.remainingAvailableUsd,
        'totalParticipants': value.totalParticipants,
    };
}
exports.CommunityPoolProgressToJSON = CommunityPoolProgressToJSON;
